/*
 * Nao ha `EnumPasswordStrength` aqui, de proposito: ele veio orfao na copia do
 * accounts e nao ha tela de senha num app de SSO -- quem cuida de credencial e
 * o liberty/auth.
 */

/**
 * As rotas que esta aplicacao atende sem sessao.
 *
 * `/sso` e a entrada vinda do admin. `/entrar` so existe em desenvolvimento
 * local (o caminho fica em portugues: outros apps o usam como destino de retorno), quando nao ha admin para emitir ticket -- em ambiente publicado ela
 * responde com um aviso e manda a pessoa para o admin (ver LocalLoginPage.vue).
 */
export const PublicRoutes = Object.freeze(['/sso', '/entrar']);

export const languages = [
    { code: 'en-US', label: 'English', flag: '/images/static/flags/usa.svg', alt: 'USA' },
    { code: 'es-ES', label: 'Español', flag: '/images/static/flags/spain.svg', alt: 'España' },
    { code: 'pt-BR', label: 'Português', flag: '/images/static/flags/brasil.svg', alt: 'Brasil' },
];

export const FormLayout = {
    Check: 2,
    Reply: 3,
};

export const ColumnTable = {
    actions: {
        width: '30px',
        smallScreenWidth: '20px',
    },
    name: {
        width: '130px',
        maxChars: 49,
        smallScreenWidth: '100px',
        smallScreenMaxChars: 25,
    },
    default: {
        width: '30px',
        maxChars: 50,
        smallScreenWidth: '60px',
        smallScreenMaxChars: 14,
    },
};

/**
 * Alimenta a busca de telas do cabecalho. `url` e a permissao no catalogo --
 * e por ela que o item so aparece para quem pode abrir a tela.
 */
export const MenuConfig = [
    { route: '/meetings', i18nKey: 'components.ata.meetings.pageTitle', url: 'ata/Meetings/List' },
    { route: '/usage', i18nKey: 'components.ata.usage.pageTitle', url: 'ata/Usage/List' },
    { route: '/sectors', i18nKey: 'components.ata.sectors.pageTitle', url: 'ata/Sectors/List' },
    { route: '/providers', i18nKey: 'components.ata.providers.pageTitle', url: 'ata/Providers/List' },
    { route: '/storage', i18nKey: 'components.ata.storage.pageTitle', url: 'ata/Storage/List' },
    { route: '/files', i18nKey: 'components.ata.files.pageTitle', url: 'ata/Files/List' },
];

export const icons = [
    'mdi-account',
    'mdi-account-cog',
    'mdi-account-group',
    'mdi-account-lock',
    'mdi-domain',
    'mdi-security',
    'mdi-shield-lock',
    'mdi-cog',
    'mdi-cog-outline',
];
